import { render, staticRenderFns } from "./BroadcastListInfo.vue?vue&type=template&id=984a91d4&"
import script from "./BroadcastListInfo.vue?vue&type=script&lang=js&"
export * from "./BroadcastListInfo.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastListInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports